export enum TranslationKey {
    notifyMe = 'Notify me when the product becomes available',
    thankYou = 'ThankYou',
    notifyMeSuccess = 'NotifyMesubscriptionSuccess',
    email = 'E-mail',
    sms = 'SMS',
    enterYourEmail = 'Enter your email below to be notified when this item is back on stock.',
    enterTelephoneNumber = 'Enter telephone number',
    invalidEmail = 'E-mail address is not valid.',
}
